import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

interface ClientReferralRejectionModalProps {
  isOpen: boolean;
  companyName: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ClientReferralRejectionModal({ 
  isOpen, 
  companyName, 
  onConfirm, 
  onCancel 
}: ClientReferralRejectionModalProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent 
        className="z-[100]"
        overlayClassName="z-[100]"
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="space-grotesk text-red-600">
            Reject Client Referral?
          </AlertDialogTitle>
          <AlertDialogDescription className="space-grotesk">
            You are about to reject the client referral for <strong>{companyName}</strong>. 
            This action will permanently change their status to "Rejected" and they will no longer be considered as a potential client.
            <br /><br />
            Are you sure you want to continue?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button
              variant="secondary"
              onClick={onCancel}
              className="space-grotesk"
            >
              Cancel
            </Button>
          </AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button
              variant="destructive"
              onClick={onConfirm}
              className="space-grotesk"
            >
              Reject Client Referral
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
